module.exports = __webpack_public_path__ + "assets/097004483a97373ad5c0045be854c2b7.png";